export enum MeasurementSystem {
    METRIC = 'metric',
    IMPERIAL = 'imperial'
}

export enum WeightUnit {
    KGS = 'kgs',
    LBS = 'lbs',
}

export enum VolumeUnit {
    CBM = 'cbm',
    CFT = 'cft',
}

export enum DimensionUnit {
    CM = 'cm',
    IN = 'in',
}
